/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromptLibraryItem
 */
export interface PromptLibraryItem {
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryItem
     */
    displayText: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryItem
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryItem
     */
    type: PromptLibraryItemTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PromptLibraryItem
     */
    autoSubmit: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromptLibraryItem
     */
    icon?: string;
}


/**
 * @export
 */
export const PromptLibraryItemTypeEnum = {
    Text: 'text',
    File: 'file'
} as const;
export type PromptLibraryItemTypeEnum = typeof PromptLibraryItemTypeEnum[keyof typeof PromptLibraryItemTypeEnum];


/**
 * Check if a given object implements the PromptLibraryItem interface.
 */
export function instanceOfPromptLibraryItem(value: object): value is PromptLibraryItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayText' in value) || value['displayText'] === undefined) return false;
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('autoSubmit' in value) || value['autoSubmit'] === undefined) return false;
    return true;
}

export function PromptLibraryItemFromJSON(json: any): PromptLibraryItem {
    return PromptLibraryItemFromJSONTyped(json, false);
}

export function PromptLibraryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptLibraryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'displayText': json['displayText'],
        'prompt': json['prompt'],
        'type': json['type'],
        'autoSubmit': json['autoSubmit'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function PromptLibraryItemToJSON(json: any): PromptLibraryItem {
    return PromptLibraryItemToJSONTyped(json, false);
}

export function PromptLibraryItemToJSONTyped(value?: PromptLibraryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'displayText': value['displayText'],
        'prompt': value['prompt'],
        'type': value['type'],
        'autoSubmit': value['autoSubmit'],
        'icon': value['icon'],
    };
}

